/**
* 头部菜单
*/ 
<template>
  <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff" active-text-color="#fff">
    <el-button class="buttonimg">
      <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
    </el-button>
    <el-submenu index="2" class="submenu">
      <!-- <template slot="title">{{user.userRealName}}</template> -->
      <template slot="title">{{user.username}}</template>
      <el-menu-item v-if="user.Permissions_type == 1" index="2-1" @click="openpas">修改密码</el-menu-item>
      <!-- <el-menu-item @click="content()" index="2-2">个人中心</el-menu-item> -->
      <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
    </el-submenu>


    <el-dialog title="修改密码" width="600px" class="icon-dialog" :visible.sync="editFormVisible" >
			<el-form size="small" ref="form" :model="form" :rules="rules" :label-width="$store.getters.device !== 'mobile'?'16%':'90px'">
        <el-row>
					<el-col :span="24">
						<el-form-item label="新密码" prop="password">
							<el-input v-model="form.password" autoComplete="off" clearable
								placeholder="请输入新密码" :show-password="true" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
        <el-row>
					<el-col :span="24">
						<el-form-item label="确认密码" prop="new_password">
							<el-input v-model="form.new_password" autoComplete="off" clearable
								placeholder="请再次输入新密码" :show-password="true" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" :loading="loading" type="primary" @click="submitForm('form')" >
					<span v-if="!loading">确 定</span>
					<span v-else>提 交 中...</span>
				</el-button>
				<el-button size="small" @click="closeForm">取 消</el-button>
			</div>
		</el-dialog>


  </el-menu>
</template>
<script>
import { setPadws } from '../api/userMG'
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {},
      editFormVisible:false,
      loading:false,
      form:{
        password:'',
        new_password:''
      },
      rules:{
        password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        new_password: [{ required: true, message: '请再次输入新密码', trigger: 'blur' }],
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
  },
  methods: {
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          window.localStorage.clear()
            // 状态保持清除后刷新页面
              window.location.reload()
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
          // loginout()
          //   .then(res => {
          //     if (res.success) {
          //       //如果请求成功就让他2秒跳转路由
          //       setTimeout(() => {
          //         this.$store.commit('logout', 'false')
          //         this.$router.push({ path: '/login' })
          //         this.$message({
          //           type: 'success',
          //           message: '已退出登录!'
          //         })
          //       }, 1000)
          //     } else {
          //       this.$message.error(res.msg)
          //       this.logining = false
          //       return false
          //     }
          //   })
          //   .catch(err => {
          //     // 获取图形验证码
          //     this.getcode()
          //     this.logining = false
          //     this.$message.error('退出失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    openpas(){
      this.editFormVisible = true
    },
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          console.log(form);
          if(this.form.password != this.form.new_password){
            this.$message({
               type: 'error',
               message: '两次密码不一致'
             })
          }else{
            setPadws(this.form).then(res=>{
              console.log(res);
              if(res.code == 200){
                this.$message({type: 'success',message: '修改成功'})
                window.localStorage.clear()
            // 状态保持清除后刷新页面
              window.location.reload()
                setTimeout(()=>{
                   this.$store.commit('logout', 'false')
                   this.$router.push({ path: '/login' })
                },1000)
              }else{
                this.$message({type: 'error',message: res.msg})
              }
            })
          }
        } 
      })
    },
    closeForm(){
      this.editFormVisible = false
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue